export const view014ImageOptions = {
  angle: 'view014',
  staticOptions: {
    HullColour: 1,
    BiminiColor: 1,
    BowOption: 1,
    UpholsteryCockpit: 1,
    Engine: 1,
    AnchorStern: 1,
    AnchorBow: 1,
    Galley: 1
  },
  mattes: [
    {
      option: 'UpholsteryCockpit',
      dependency: 'TTop'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/view014.js